import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class ProformaInvoiceService {
    static List(item) {
        const api = `${API_PATHS.performaList}`;
        const formData = new FormData();

        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                formData.append(key, item[key]);
            }
        }

        return axios
            .post(api, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static NextNumber(item) {
        const api = `${API_PATHS.performaNextNumber}`;
        const formData = new FormData();

        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                formData.append(key, item[key]);
            }
        }

        return axios
            .post(api, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static Add(item) {
        const api = `${API_PATHS.performaAdd}`;

        return axios
            .post(api, item, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static Detail(item) {
        const api = `${API_PATHS.performaDetail}`;
        const formData = new FormData();

        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                formData.append(key, item[key]);
            }
        }

        return axios
            .post(api, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static Customer(item) {
        const api = `${API_PATHS.performaCustomer}`;
        const formData = new FormData();

        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                formData.append(key, item[key]);
            }
        }

        return axios
            .post(api, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static Update(item) {
        const api = `${API_PATHS.performaUpdate}`;

        return axios
            .post(api, item, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }

    static Delete(item) {
        const api = `${API_PATHS.performaDelete}`;
        const formData = new FormData();

        for (const key in item) {
            if (item.hasOwnProperty(key)) {
                formData.append(key, item[key]);
            }
        }

        return axios
            .post(api, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => response.data);
    }
}

export default ProformaInvoiceService;
